export default __webpack_public_path__ + "static/media/SLIIT_Logo_Crest.a12bee6d.png";